import Vue from 'vue'
import Vuex from 'vuex'

import general from './modules/general'
import contract from './modules/contract'
import specialOffer from './modules/special-offer'
import emailHistory from './modules/email-history'

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    general,
    contract,
    specialOffer,
    emailHistory
  }
})

export default store
